import React from 'react';
import { MedicalProfileFiles } from '../../../primary-record-types';
import SizedView from '../../v2BaseComponents/SizedView';
import { maybeRotateBoundingBox } from './utils';
import { View } from 'react-native';
import { colors } from '../../../utils/theme';

export type BoundingBoxDisplayOwnProps = {
    children: any;
    boundingBox: MedicalProfileFiles.BoundingBox | null;
    rotation: MedicalProfileFiles.Rotation | null;
    imageType: 'pdf-image' | 'image';
    boundingBoxPadding?: number;
};

export type BoundingBoxDisplayProps = BoundingBoxDisplayOwnProps;

const BoundingBoxDisplay: React.FC<BoundingBoxDisplayProps> = (props) => {
    if (props.boundingBox === null || props.rotation === null || props.imageType === null) return props.children;

    const maybeRotatedBoundingBox = maybeRotateBoundingBox(props.boundingBox, props.rotation, props.imageType);

    const padding = props.boundingBoxPadding === undefined ? 0.01 : props.boundingBoxPadding;

    return (
        <SizedView style={{ position: 'relative' }} lazyEvaluateWidth>
            {({ height, width }) => (
                <>
                    {props.children}
                    <View
                        collapsable={false}
                        style={{
                            position: 'absolute',
                            top: (maybeRotatedBoundingBox.top - padding) * height,
                            left: (maybeRotatedBoundingBox.left - padding) * width,
                            width: (maybeRotatedBoundingBox.width + padding * 2) * width,
                            height: (maybeRotatedBoundingBox.height + padding * 2) * height,
                            borderWidth: 2,
                            backgroundColor: colors['Primary-Reg'],
                            opacity: 0.15,
                        }}
                    />
                </>
            )}
        </SizedView>
    );
};

export default React.memo(BoundingBoxDisplay);
